export const SHOW_SKELETON_FOR_LATEST_SERIES =
  "SHOW_SKELETON_FOR_LATEST_SERIES";
export const SHOW_SKELETON_FOR_LATEST_MOVIES =
  "SHOW_SKELETON_FOR_LATEST_MOVIES";
export const SHOW_SKELETON_FOR_SEARCH = "SHOW_SKELETON_FOR_SEARCH";
